'use client'

import { useState } from 'react'

import { Button } from '@/core/components/form/button/button'
import SafeImage from '@/core/components/safe-image'
import { cn } from '@/core/utils/common'

type ProductGalleryProps = {
  images: string[]
  alt: string
}

export default function ProductGallery({ images, alt }: ProductGalleryProps) {
  const [current, setCurrent] = useState(0)
  const active = images[Math.min(current, images.length - 1)]

  return (
    <div>
      <div className="relative aspect-square overflow-hidden rounded-panel bg-surface-soft">
        {active && (
          <SafeImage
            src={active}
            alt={alt}
            fill
            unoptimized={active.endsWith('.svg')}
            priority
            sizes="(min-width: 1001px) 500px, 100vw"
            className="object-cover"
          />
        )}
      </div>
      {images.length > 1 && (
        <div className="scrollbar-none mt-3 flex gap-2 overflow-x-auto">
          {images.map((image, index) => (
            <Button
              key={image}
              type="button"
              variant="ghost"
              aria-label={`${index + 1}번째 이미지 보기`}
              aria-pressed={index === current}
              onClick={() => setCurrent(index)}
              className={cn(
                'relative size-20 shrink-0 overflow-hidden rounded-control border-2 p-0',
                index === current ? 'border-foreground' : 'border-transparent'
              )}
            >
              <SafeImage
                src={image}
                alt=""
                fill
                unoptimized={image.endsWith('.svg')}
                sizes="80px"
                className="object-cover"
              />
            </Button>
          ))}
        </div>
      )}
    </div>
  )
}
